export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Direct-Gray-5c38e202e8f471455d9744ab07c47b0e.svg";